module.exports = __webpack_public_path__ + "img/other-logo-luceville.3c812c81.png";